import React from "react";
import styles from "./row.module.css";

function Row(props) {
  return <div className={`${styles.row}`}>{props.children}</div>;
}

export default Row;
